// extracted by mini-css-extract-plugin
export default {"container":"VersionHistoryCard_container__U-Tfh","info":"VersionHistoryCard_info__lb7km","moreIcon":"VersionHistoryCard_moreIcon__UTLxq"};